module.exports = __webpack_public_path__ + "img/qbit-top-banner-sm.a312bf8b.png";